import React, { useEffect, useState } from "react";
import InvestmentComponent from "./InvestmentComponent";
import getServices from "../../Services/getServices";
import House from "../../Assets/images/house.png";
import EmptyStateGif from "../../Assets/gif/gif.gif";

function Investment() {
  const [data, setData] = useState([]);

  const getData = () => {
    getServices
      .getAllInvestments()
      .then((response) => {
        setData(response.data?.data || []);
      })
      .catch((error) => {
        setData([]);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const filteredData =
    data && data.length > 0
      ? data.filter((item) => item.projectStatus === "active")
      : [];

  return (
    <div>
      <div className="md:mt-10 flex mb-6 mt-4 justify-between">
        <h1 className="text-[16px] mb-3 pl-5 md:pl-0 md:text-[32px] font-[800] text-back-color2">
          Recent Investment Opportunities
        </h1>
      </div>

      {filteredData.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-10">
          <img
            src={EmptyStateGif}
            alt="No record available"
            className="w-48 h-48 object-contain"
          />
          <p className="text-center text-gray-500 text-xl mt-4">
            Any recent investment will appear here
          </p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-3 gap-3">
          {filteredData.slice(0, 3).map((item, index) => (
            <div key={index}>
              <InvestmentComponent
                name={item.projectName}
                location={item.projecLocation || "No location"}
                raised={item.pricePerUnit * item.unitSold}
                target={item.projectPriceTotal}
                percent={Math.ceil(item.percentAvailable)}
                image={item.imageUrl?.[0] || House}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Investment;
